import { graphql } from 'gatsby';
import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';

import FeaturedStory from '~/components/blocks/acf/FeaturedStory';

import { useAllPosts } from '~/hooks/useAllPosts';

const FeaturedStoryBlock = ({
    attributes,
    globalBlockOptions: { globalBlockOptions },
    blockFeaturedStory: { subtitle, story }
}) => {
    const posts = useAllPosts();

    const featuredPost = !isEmpty(story)
        ? story[0]
        : !isEmpty(posts)
          ? posts[0]
          : {};

    return (
        <FeaturedStory
            {...{
                attributes,
                globalBlockOptions,
                subtitle
            }}
            {...featuredPost}
        />
    );
};

FeaturedStoryBlock.propTypes = {
    blockFeaturedStory: PropTypes.shape({
        subtitle: PropTypes.string,
        story: PropTypes.arrayOf(PropTypes.shape({}))
    }).isRequired
};

export default FeaturedStoryBlock;

export const fragment = graphql`
    fragment FeaturedStoryBlockFragment on WpAcfFeaturedStoryBlock {
        name
        attributes {
            anchor
            className
        }
        globalBlockOptions {
            globalBlockOptions {
                marginBottom
            }
        }
        blockFeaturedStory {
            subtitle
            story {
                ... on WpPost {
                    id
                    title
                    uri
                    excerpt
                    featuredImage {
                        node {
                            id
                            altText
                            sourceUrl
                            localFile {
                                childImageSharp {
                                    gatsbyImageData(aspectRatio: 1.4)
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const exampleData = [
    {
        variant: 'Default Featured Story',
        description:
            'Optional Subtitle. Select a specific post or deault to the most recent post.',
        props: {
            name: 'acf/featured-story',
            blockFeaturedStory: {
                subtitle: 'Subtitle',
                story: [
                    {
                        id: '123',
                        title: 'Title',
                        uri: '#',
                        excerpt:
                            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                        featuredImage: {
                            node: {
                                id: '123',
                                sourceUrl: 'https://picsum.photos/850/600'
                            }
                        }
                    }
                ]
            }
        }
    }
];
